import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vueScrollto from 'vue-scrollto'
//import Meta from 'vue-meta';
import VueHead from 'vue-head'

//Vue.use(Meta);
Vue.use(VueHead)
Vue.use(vueScrollto)

Vue.config.productionTip = false;

new Vue({
  router,
  render: h => h(App),
  data: {
    phonesObject: {
      Apple: {
        img: require('@/assets/img/applelogo.png'),
        memmoryModels: false,
        models: [
          {
            'name': 'iPhone SE',
            'maxPrice': 10800,
            'minPrice': 2400,
            img: require('@/assets/img/iphonese.jpg')
          },
          {
            'name': 'iPhone 6',
            'maxPrice': 12000,
            'minPrice': 3600,
            img: require('@/assets/img/iphone6s.jpg')
          },
          {
            'name': 'iPhone 6 Plus',
            'maxPrice': 13200,
            'minPrice': 3600,
            img: require('@/assets/img/iphone6s.jpg')
          },
          {
            'name': 'iPhone 6s',
            'maxPrice': 14400,
            'minPrice': 3600,
            img: require('@/assets/img/iphone6s.jpg')
          },
          {
            'name': 'iPhone 6s Plus',
            'maxPrice': 17400,
            'minPrice': 3600,
            img: require('@/assets/img/iphone6s.jpg')
          },
          {
            'name': 'iPhone 7',
            'maxPrice': 24000,
            'minPrice': 9600,
            'img': require('@/assets/img/iphone7.jpg')
          },
          {
            'name': 'iPhone 7 Plus',
            'maxPrice': 28800,
            'minPrice': 12000,
            'img': require('@/assets/img/iphone7.jpg')
          },
          {
            'name': 'iPhone 8',
            'maxPrice': 42000,
            'minPrice': 21600,
            'img': require('@/assets/img/iphone8.jpg')
          },
          {
            'name': 'iPhone 8 Plus',
            'maxPrice': 45600,
            'minPrice': 24000,
            'img': require('@/assets/img/iphone8+.jpg')
          },
          {
            'name': 'iPhone X',
            'maxPrice': 66000,
            'minPrice': 18000,
            'img': require('@/assets/img/iphonex.jpg')
          }

        ]
      },
      Samsung: {
        img: require('@/assets/img/samsunglogo.png'),
        memmoryModels: false,
        models: [
          {
            'name': 'Galaxy S6',
            'maxPrice': 11400,
            'minPrice': 0,
            'img': require('@/assets/img/s6.jpg')
          },
          {
            'name': 'Galaxy S6 Edge',
            'maxPrice': 13200,
            'minPrice': 0,
            'img': require('@/assets/img/s6e.jpg')
          },
          {
            'name': 'Galaxy S6 Edge Plus',
            'maxPrice': 15000,
            'minPrice': 0,
            'img': require('@/assets/img/s6+.jpg')
          },
          {
            'name': 'Galaxy A8',
            'maxPrice': 14400,
            'minPrice': 2400,
            'img': require('@/assets/img/a8.jpg')
          },
          {
            'name': 'Galaxy A8 Plus',
            'maxPrice': 19200,
            'minPrice': 3600,
            'img': require('@/assets/img/a8.jpg')
          },
          {
            'name': 'Galaxy S7',
            'maxPrice': 16800,
            'minPrice': 2400,
            'img': require('@/assets/img/s7.jpg')
          },
          {
            'name': 'Galaxy S7 Edge',
            'maxPrice': 19200,
            'minPrice': 0,
            'img': require('@/assets/img/s7edge.jpg')
          },
          {
            'name': 'Galaxy S8',
            'maxPrice': 31200,
            'minPrice': 6000,
            'img': require('@/assets/img/s8.png')
          },
          {
            'name': 'Galaxy S8 Plus',
            'maxPrice': 36000,
            'minPrice': 7200,
            'img': require('@/assets/img/s8+.png')
          },
          {
            'name': 'Note 8',
            'maxPrice': 42000,
            'minPrice': 12000,
            'img': require('@/assets/img/note8.jpg')
          },
          {
            'name': 'Galaxy S9',
            'maxPrice': 44400,
            'minPrice': 14400,
            'img': require('@/assets/img/s9.png')
          },
          {
            'name': 'Galaxy S9 Plus',
            'maxPrice': 50400,
            'minPrice': 19200,
            'img': require('@/assets/img/s9+.png')
          }
        ]
      },
      Huawei: {
        img: require('@/assets/img/huaweilogo.png'),
        memmoryModels: false,
        models: [
          {
            'name': 'P10',
            'maxPrice': 14400,
            'minPrice': 2400,
            'img': require('@/assets/img/p10.jpg')
          },
          {
            'name': 'P10 Plus',
            'maxPrice': 18000,
            'minPrice': 4800,
            'img': require('@/assets/img/p10+.jpg')
          },
          {
            'name': 'Mate 9',
            'maxPrice': 14400,
            'minPrice': 0,
            'img': require('@/assets/img/mate9.jpg')
          },
          {
            'name': 'Mate 10',
            'maxPrice': 27600,
            'minPrice': 9600,
            'img': require('@/assets/img/mate10.jpg')
          },
          {
            'name': 'Mate 10 Pro',
            'maxPrice': 32400,
            'minPrice': 6000,
            'img': require('@/assets/img/mate10pro.jpg')
          },
          {
            'name': 'Mate 10 Lite',
            'maxPrice': 10800,
            'minPrice': 0,
            'img': require('@/assets/img/mate10lite.jpg')
          },
          {
            'name': 'Honor 9',
            'maxPrice': 18000,
            'minPrice': 2400,
            'img': require('@/assets/img/honor9.jpg')
          },
          {
            'name': 'P20',
            'maxPrice': 37200,
            'minPrice': 20400,
            'img': require('@/assets/img/p20.jpg')
          },
          {
            'name': 'P20 Pro',
            'maxPrice': 43200,
            'minPrice': 15600,
            'img': require('@/assets/img/p20pro.jpg')
          },
          {
            'name': 'P20 Lite',
            'maxPrice': 15600,
            'minPrice': 4800,
            'img': require('@/assets/img/p20lite.jpg')
          }
        ]
      },
      'LG': {
        img: require('@/assets/img/lglogo.png'),
        memmoryModels: false,
        models: [
          {
            'name': 'LG G6',
            'maxPrice': 12000,
            'minPrice': 0,
            'img': require('@/assets/img/g6.jpg')
          }
        ]
      },
      Nokia: {
        img: require('@/assets/img/nokialogo.png'),
        memmoryModels: false,
        models: [
          {
            'name': 'Nokia 6',
            'maxPrice': 6000,
            'minPrice': 0,
            'img': require('@/assets/img/m6.jpg')
          },
          {
            'name': 'Nokia 8',
            'maxPrice': 12000,
            'minPrice': 0,
            'img': require('@/assets/img/m8.jpg')
          }

        ]
      },
      Sony: {
        img: require('@/assets/img/sonylogo.png'),
        memmoryModels: false,
        models: [
          {
            'name': 'XZ1',
            'maxPrice': 18000,
            'minPrice': 3600,
            'img': require('@/assets/img/xz1.jpg')
          },
          {
            'name': 'XZ1 Compact',
            'maxPrice': 9600,
            'minPrice': 0,
            'img': require('@/assets/img/xz1c.jpg')
          },
          {
            'name': 'XA2',
            'maxPrice': 6000,
            'minPrice': 0,
            'img': require('@/assets/img/xa2.jpg')
          },
          {
            'name': 'XA2 Ultra',
            'maxPrice': 7200,
            'minPrice': 0,
            'img': require('@/assets/img/xa2u.png')
          },
          {
            'name': 'XZ2 Compact',
            'maxPrice': 18000,
            'minPrice': 3600,
            'img': require('@/assets/img/xz2compact.jpg')
          },
          {
            'name': 'XZ2',
            'maxPrice': 24000,
            'minPrice': 6000,
            'img': require('@/assets/img/xz2.jpg')
          },
          {
            'name': 'XZ',
            'maxPrice': 6000,
            'minPrice': 0,
            'img': require('@/assets/img/xz.jpg')
          },
          {
            'name': 'XZ Premium',
            'maxPrice': 9600,
            'minPrice': 0,
            'img': require('@/assets/img/xzpremium.jpg')
          }

        ]
      },
      'HTC': {
        img: require('@/assets/img/htclogo.jpg'),
        memmoryModels: false,
        models: [
          {
            'name': 'U11',
            'maxPrice': 18000,
            'minPrice': 4800,
            'img': require('@/assets/img/u11.jpg')
          },
          {
            'name': 'U Ultra',
            'maxPrice': 6000,
            'minPrice': 0,
            'img': require('@/assets/img/uultra.jpg')
          },
          {
            'name': 'HTC 10',
            'maxPrice': 6000,
            'minPrice': 0,
            'img': require('@/assets/img/htc10.jpg')
          }
        ]
      }

    },
      questionsList:{
          functional:{
              title: "Da li je uređaj funkcionalan?",
              tooltip: "Da li se uređaj uključuje, radi ispravno i bez ikakvih problema?",
              img: require('@/assets/img/functional.png'),
              subtitle: "Da li je uređaj u potpunosti ispravan?",
              id1: "func1",
              id2: "func2",
              model: null
          },
          display:{
              title: "Ekran",
              tooltip: "Ekran je bez pukotina, nagnječenja, delaminacija, opekotina i drugih naznaka fizičkog oštećenja.",
              img: require('@/assets/img/display.png'),
              subtitle: "Da li je ekran u u dobrom stanju?",
              id1: "disp1",
              id2: "disp2",
              model: null
          },
          cover: {
              title: "Zadnji poklopac",
              tooltip: "Zadnji poklopac je bez pukotina, nagnječenja i drugi naznaka fizičkog oštećenja.",
              img: require('@/assets/img/cover.png'),
              subtitle: "Da i je zadnji poklopac u dobrom stanju?",
              id1: "enc1",
              id2: "enc2",
              model: null
          },
          buttons: {
              title: "Tasteri",
              tooltip: "Proveriti da li dugmad za jačinu zvuka i uključivanje, tasteri za povratak i “home” taster funkcionišu pravilno na dodir.",
              img: require('@/assets/img/buttons.png'),
              subtitle: "Da li su svi tasteri u dobrom stanju?",
              id1: "btns1",
              id2: "btns2",
              model: null
          },
          liquid: {
              title: "Bez znakova oksidacije?",
              tooltip: "Pronađite indikatore za kontakt sa vlagom u vašem uređaju i proverite da li je kontrolna traka bele ili crvene boje. Crvena boje označava da je uređaj došao u kontakt sa vlagom.",
              img: require('@/assets/img/liquid.png'),
              subtitle: "Da li je uredjaj bez naznaka dodira sa tečnošću / vlagom?",
              id1: "liq1",
              id2: "liq2",
              model: null
          },
          network: {
              title: "Network",
              tooltip: "Locate the liquid damage indicator and make sure It is white and not pink or red which indicates water damage.",
              img: require('@/assets/img/network.png'),
              subtitle: "Is the device free from obvious signs of liquid contact?",
              id1: "net1",
              id2: "net2",
              model: true, //Toggle to null when used
              variation: true
          }
      }
  }
}).$mount('#app')
